import React, { useState } from 'react';
import { Layout, Row, Col, Typography, Button, Space } from 'antd';
import { 
  CheckCircleOutlined, 
  DollarOutlined, 
  BarChartOutlined,
  SettingOutlined,
  DownOutlined,
  RightOutlined,
  ArrowRightOutlined
} from '@ant-design/icons';
import './Home.scss';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const Home: React.FC = () => {
  const [expandedFaq, setExpandedFaq] = useState(0);

  const faqData = [
    {
      question: "Is There a Free Trial Available?",
      answer: "Yes, you can try us for free for 7 days. If you want, we'll provide you with a free 30-minute onboarding call to get you up and running."
    },
    {
      question: "Can i Change My Plan Later",
      answer: "Absolutely! You can upgrade or downgrade your plan at any time. Changes will be reflected in your next billing cycle."
    },
    {
      question: "What is Your Cancellation Policy",
      answer: "You can cancel your subscription at any time. We'll continue to provide service until the end of your current billing period."
    },
    {
      question: "Can Other info to be Added in Invoice?",
      answer: "Yes, our invoice system is highly customizable. You can add custom fields, logos, terms, and any additional information you need."
    },
    {
      question: "How is your Billing Woks",
      answer: "We offer flexible billing options including monthly and yearly plans. All payments are processed securely through our trusted payment partners."
    }
  ];

  const toggleFaq = (index: number) => {
    setExpandedFaq(expandedFaq === index ? -1 : index);
  };

  return (
    <Layout className="home-layout">
      <Content>
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-container">
            <div className="hero-content">
              {/* <div className="hero-badge">
                <span className="badge-icon">📝</span>
                Introducing Byondcore
              </div> */}
              <Title level={1} className="hero-title">
                Manage Your Money, <span className="highlight-text">Your Way</span>
              </Title>
              <Paragraph className="hero-description">
                A modern accounting software that gives you more time to grow your business, so you can focus on
                what matters most.              </Paragraph>
              <Space size="large" className="hero-cta">
                <Button type="primary" size="large" className="trial-btn">
                  Start Your Free Trial
                </Button>
                <Button size="large" className="contact-btn">
                  Contact Sales
                </Button>
              </Space>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <div className="section-header">
              <Title level={2} className="section-title">
                We bring the right people together to challenge established thinking and drive transformation
              </Title>
            </div>

            <Row gutter={[32, 32]}>
              <Col xs={24} md={8}>
                <div 
                  className="feature-item-bg"
                  style={{ backgroundImage: 'url(/images/shape-bg.svg)' }}
                >
                  <div className="feature-icon">
                    <BarChartOutlined />
                  </div>
                  <Title level={4}>We Innovate</Title>
                  <Paragraph>
                    We innovate systematically, continuously and successfully.
                  </Paragraph>
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div 
                  className="feature-item-bg"
                  style={{ backgroundImage: 'url(/images/shape-bg.svg)' }}
                >
                  <div className="feature-icon">
                    <DollarOutlined />
                  </div>
                  <Title level={4}>Performance</Title>
                  <Paragraph>
                    Performance is about solving problems and building business.
                  </Paragraph>
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div 
                  className="feature-item-bg"
                  style={{ backgroundImage: 'url(/images/shape-bg.svg)' }}
                >
                  <div className="feature-icon">
                    <SettingOutlined />
                  </div>
                  <Title level={4}>A Full Service</Title>
                  <Paragraph>
                    We are a full service business solutions provider.
                  </Paragraph>
                </div>
              </Col>
            </Row>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq-section">
          <div className="container">
            <Row gutter={[48, 48]}>
              <Col xs={24} lg={12}>
                <div className="faq-content">
                  <div className="faq-badge">FAQ</div>
                  <Title level={2} className="faq-title">
                    Got a Question? Get your <span className="highlight">Answer</span>
                  </Title>
                  <Paragraph className="faq-description">
                    Quick answers to questions you may have. Can't find what you're looking for? Check out our full documentation.
                  </Paragraph>
                </div>
              </Col>
              <Col xs={24} lg={12}>
                <div className="faq-list">
                  {faqData.map((faq, index) => (
                    <div 
                      key={index} 
                      className={`faq-item ${expandedFaq === index ? 'expanded' : ''}`}
                      onClick={() => toggleFaq(index)}
                    >
                      <div className="faq-question">
                        <span>{faq.question}</span>
                        {expandedFaq === index ? <DownOutlined /> : <RightOutlined />}
                      </div>
                      {expandedFaq === index && (
                        <div className="faq-answer">
                          {faq.answer}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </section>

        {/* Get Started Section */}
        <section className="get-started-section">
          <div className="container">
            <div className="get-started-content">
              <Title level={2} className="get-started-title">
                Get Started With Byondcore SAAS
              </Title>
              <Paragraph className="get-started-description">
                Byondcore is a complete accounts & finance admin dashboard for your business & fully equipped with various functionalities and is platform compatible.
              </Paragraph>
              <Button type="primary" size="large" className="demo-button">
                Click Here for Demo <ArrowRightOutlined />
              </Button>
            </div>
          </div>
        </section>
      </Content>
    </Layout>
  );
};

export default Home; 